import { render, staticRenderFns } from "./AlertSnackBar.vue?vue&type=template&id=58bb2e53&scoped=true"
import script from "./AlertSnackBar.vue?vue&type=script&lang=js"
export * from "./AlertSnackBar.vue?vue&type=script&lang=js"
import style0 from "./AlertSnackBar.vue?vue&type=style&index=0&id=58bb2e53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb2e53",
  null
  
)

export default component.exports